(() => {
  const CHECKBOX_ID = 'cbx';

  function isChecked() {
    const cb = document.getElementById(CHECKBOX_ID);
    return !!cb && cb.checked;
  }

  function applyLock() {
    const ok = isChecked();

    // Disable any normal checkout buttons (cart page + cart drawer)
    document
      .querySelectorAll('button[name="checkout"], input[name="checkout"], #checkout')
      .forEach((el) => {
        if (el instanceof HTMLButtonElement || el instanceof HTMLInputElement) {
          el.disabled = !ok;
        }
      });

    // Also block checkout links if any theme uses them
    document
      .querySelectorAll('a[href^="/checkout"], a[href*="/checkout"]')
      .forEach((a) => {
        a.style.pointerEvents = ok ? '' : 'none';
        a.style.opacity = ok ? '' : '0.6';
      });

    // Prevent bypass: hide accelerated checkout buttons until checked
    document
      .querySelectorAll('.additional-checkout-buttons, .shopify-payment-button, [data-shopify="payment-button"]')
      .forEach((el) => {
        el.style.display = ok ? '' : 'none';
      });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', applyLock);

  // Run when checkbox changes (even after re-render)
  document.addEventListener('change', (e) => {
    if (e.target && e.target.id === CHECKBOX_ID) applyLock();
  });

  // Run whenever Horizon re-renders the cart/drawer
  new MutationObserver(() => applyLock()).observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Extra safety: if something slips through, block checkout clicks
  document.addEventListener(
    'click',
    (e) => {
      const target = e.target.closest(
        'button[name="checkout"], input[name="checkout"], #checkout, a[href^="/checkout"], a[href*="/checkout"]'
      );
      if (target && !isChecked()) {
        e.preventDefault();
        e.stopPropagation();
        alert('Please accept the terms and conditions before checking out.');
      }
    },
    true
  );
})();
